<script>
    import { db, functions } from './stores.js';
    import Datepicker from './components/Datepicker.svelte';

    export let mode;
    export let tutorials=null;

    let url;
    let provider = "twitter.com";
    let username = "lifelongdev";
    let title;
    let description;
    let icon;
    let image;
    let keywords;
    let language;
    let status = "pending";
    let added;
    let uid;
    let outcome = "";
    let metadata;

    let tutorialSelected = false;


    function getSiteInfo(){
        if (url){
            if (!url.includes("https://")){
                url = "https://"+url;
            }
            uid = "";
            outcome = "";
            provider = "twitter.com";
            username = "lifelongdev";
            console.log("getSiteInfo: ",url);
            const getSiteInfo = $functions.httpsCallable("getSiteInfo");
            getSiteInfo({url})
                .then((result) => {
                    metadata = result.data.metadata;
                    // console.log({result});
                    title = metadata.title;
                    description = metadata.description;
                    icon = metadata.icon;
                    image = metadata.image;
                    if (metadata.keywords){
                        keywords = metadata.keywords.join(", ");
                    }
                    language = metadata.language;
                }).catch((error) => {
                    console.log({error});
                });
        };
    };

    function addTutorial(){
        console.log("add tutorial");
        $db.collection("tutorials").add({
            title,
            description,
            icon,
            image,
            keywords: keywords.split(", "),
            language,
            provider,
            username,
            added,
            status,
            url
        }).then((docRef) => {
            console.log("tutorial successfully added! ID: ", docRef.id);
            uid = docRef.id;
            outcome = `Tutorial created: ${uid}`;
        }).catch((error) => {
            console.error("Error adding tutorial: ", error);
            outcome = `Error: ${error}`;
        });
    };

    function updateTutorial(){
        console.log("save tutorial");
        $db.collection("tutorials").doc(`${uid}`).set({
            title,
            description,
            icon,
            image,
            keywords: keywords.split(", "),
            language,
            provider,
            username,
            added,
            status,
            url
        }, {merge: true}).then(() => {
            console.log("tutorial successfully updated!");
            outcome = "tutorial successfully updated!"
        }).catch((error) => {
            console.error("Error updating tutorial: ", error);
            outcome = `Error updating tutorial: ${error}`;
        });
    };

    function deleteTutorial(){
        console.log("delete tutorial");
        $db.collection("tutorials").doc(`${uid}`).delete().then(() => {
            console.log("tutorial successfully deleted!");
            outcome = "tutorial successfully deleted!";
        }).catch((error) => {
            console.error("Error deleting tutorial: ", error);
            outcome = `Error deleting tutorial: ${error}`;
        });
    }

    function handleDateTimeChange(event){
        console.log("handleDateTimeChange: ", event);
        added = event.detail.datetimeMs;
    };

    function handleSelect(tutorial){
        handleClearTutorial();
        tutorialSelected = true;
        metadata = tutorial;
        uid = tutorial.uid;
        added = tutorial.added;
        description = tutorial.description;
        icon = tutorial.icon;
        image = tutorial.image;
        if (tutorial.keywords) {
            keywords = tutorial.keywords.join(", ");
        }
        language = tutorial.language;
        provider = tutorial.provider;
        status = tutorial.status;
        title = tutorial.title;
        url = tutorial.url;
        username = tutorial.username;

    };

    function handleClearTutorial(){
        console.log("handleClearTutorial: ");
        metadata = null;
        tutorialSelected = false;
        uid = "";
        added = "";
        description = "";
        icon = "";
        image = "";
        keywords = "";
        language = "";
        provider = "";
        status = "";
        title = "";
        url = "";
        username = "";
    };

</script>

<svelte:window on:clearTutorial={handleClearTutorial} />

<section>
    {#if tutorials}
    <div>
        {#each tutorials as tutorial}
            {tutorial.url}
            <details>
                <summary>description</summary>
                {tutorial.description}
            </details>
            <br/>submitted by: <a href="https://{tutorial.provider}/{tutorial.username}" target="_blank">{tutorial.provider}/{tutorial.username}</a>
            <br/><button on:click="{() => handleSelect(tutorial)}">select</button>
            <br/><br/>
        {/each}
    </div>
    {/if}
    {#if (mode==="add" || tutorialSelected)}
        <div>
            <input bind:value={url}>
            <button on:click={getSiteInfo}>get Metadata</button>
            {#if metadata}
                <br/> title: <input bind:value={title}>
                <br/> description: <input bind:value={description}>
                <br/> icon: <input bind:value={icon}>
                <br/> image: <input bind:value={image}>
                <br/> keywords: <input bind:value={keywords}>
                <br/> language: <input bind:value={language}>
                <br/> provider: <input bind:value={provider}>
                <br/> username: <input bind:value={username}>
                <br/> added: <input bind:value={added}>
                <br/> <Datepicker on:datetimechange={handleDateTimeChange}/>
                <br/> status:
                <br/> <select bind:value={status} name="status">
                    <option value="pending" selected={status === "pending"}>Pending</option>
                    <option value="active" selected={status === "active"}>Active</option>
                </select>
                <br/>
                {#if uid}
                    <button on:click={updateTutorial}>update</button>
                    <button on:click={deleteTutorial}>delete</button>
                {:else}
                    <button on:click={addTutorial}>add</button>
                {/if}
                <br/>{outcome}
            {/if}    
        </div>
    {:else}
        <div>select a tutorial</div>
    {/if}
</section>


<style>
    button {
        cursor: pointer;
    }
    section {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;
    }
    details {
        border: 1px solid #aaa;
        border-radius: 4px;
        padding: .5em .5em 0;
    }

    summary {
        font-weight: bold;
        margin: -.5em -.5em 0;
        padding: .5em;
        text-align: left;
    }

    details[open] {
        padding: .5em;
    }

    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: .5em;
    }

</style>